import React, { useState, useMemo, useRef } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Dropdown } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import CategoryTag from "../base/Tags/CategoryTag";
import LocationTag from "../base/Tags/LocationTag";
import { useTagsStore } from "../../store/tagsStore";

// Todo: fix inline css
// Todo: fix typescript 'any' errors

const ResultSectionHeader = ({ title }: { title: string }) => {
  return (
    <h6 className="text-1000 fs-9 border-y border-200 py-2 lh-sm mb-0 px-3">
      {title}
    </h6>
  );
};
// fix inline css
// searchValue is a prop that is passed to the SearchResult component. It is used to filter the search results based on the current input. may or may not be used
const SearchTest = () => {
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");

  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);

  const categoryInputRef = useRef(null);
  const locationInputRef = useRef(null);

  const navigate = useNavigate(); // Initialize navigate

  const providerLocation = useTagsStore((state) => state.providerLocation);
  const providerCategories = useTagsStore((state) => state.providerCategories);

  const handleLocationChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setLocation(event.target.value);
    setIsLocationDropdownOpen(true);
  };

  const handleCategoryChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setCategory(event.target.value);
    setIsCategoryDropdownOpen(true);
  };

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();

    // Construct the query parameters
    const params = new URLSearchParams();
    if (location.trim() !== "") {
      params.set("location", location.trim());
    }
    if (category.trim() !== "") {
      params.set("category", category.trim());
    }

    // Navigate to the filter page with the search query
    navigate(`/home/searchpage?${params.toString()}`);
  };

  const normalizeString = (str: string) =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  // Filtered categories for the category input
  const filteredCategories = useMemo(() => {
    const categoryNormalized = normalizeString(category.trim());
    if (categoryNormalized.length === 0) return [];
    return providerCategories.filter((c) =>
      normalizeString(c.name).startsWith(categoryNormalized)
    );
  }, [category]);

  // Filtered locations for the location input

  const filteredLocations = useMemo(() => {
    const locationNormalized = normalizeString(location.trim());
    if (locationNormalized.length === 0) return [];
    return providerLocation.filter((loc) =>
      normalizeString(loc.name).startsWith(locationNormalized)
    );
  }, [location]);

  function onSelectCategorySuggestion(category: string) {
    setCategory(category);
    setIsCategoryDropdownOpen(false);
  }

  function onSelectLocationSuggestion(location: string) {
    setLocation(location);
    setIsLocationDropdownOpen(false);
  }

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Row className="center-search search-bar ps-lg-6 ps-xl-2">
          <Col xs={10} md={12} lg={10} sm={10} xl={6} className="p-0">
            <div
              className="combined-search search-bar shadow-lg bg-white p-1"
              style={{
                overflow: "visible",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Category Search */}
              <div style={{ position: "relative", flex: 1 }}>
                <div className="d-flex align-items-center">
                  <div className="pt-1 ps-1">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                  <InputGroup>
                    <Form.Control
                      ref={categoryInputRef}
                      type="text"
                      placeholder="Mobiliario"
                      value={category}
                      onChange={handleCategoryChange}
                      className="search-field search-bar border-end"
                      aria-label="Category"
                      aria-describedby="category-addon"
                      autoComplete="off"
                    />
                  </InputGroup>
                </div>
                {isCategoryDropdownOpen && filteredCategories.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderTop: "none",
                      marginTop: "15px",
                      borderRadius: "10px 10px 5px 5px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      height: "auto", // Ensures expansion
                      // maxHeight: 'none', // Prevents restriction
                      zIndex: 9999, // Ensures it stays on top

                      overflowY: "visible", // Prevents unwanted scrolling
                    }}
                  >
                    <h6 className="text-1000 fs-10 py-2 mb-0 px-3">
                      {filteredCategories.length}{" "}
                      <span className="text-500">Resultados</span>
                    </h6>
                    <ResultSectionHeader title="Categorías" />
                    <div
                      className="py-2 d-flex "
                      style={{
                        maxWidth: "",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {filteredCategories.map((category) => (
                        <Dropdown.Item
                          className="d-flex flex-wrap align-items-center p-2 "
                          style={{ whiteSpace: "normal", width: "auto" }} // Ensures wrapping
                          as="button"
                          key={category.name}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() =>
                            onSelectCategorySuggestion(category.name)
                          }
                        >
                          <CategoryTag category={category.name} />
                        </Dropdown.Item>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Location Search */}
              <div style={{ position: "relative", flex: 1 }}>
                <div className="d-flex align-items-center">
                  <div className="pt-1 ps-1">
                    <FontAwesomeIcon icon={faEarthAmericas} />
                  </div>
                  <InputGroup>
                    <Form.Control
                      ref={locationInputRef}
                      type="text"
                      placeholder="Ubicación"
                      value={location}
                      onChange={handleLocationChange}
                      className="search-field search-bar w-100"
                      aria-label="Location"
                      aria-describedby="location-addon"
                      autoComplete="off"
                    />
                  </InputGroup>
                </div>

                {isLocationDropdownOpen && filteredLocations.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderTop: "none",
                      marginTop: "15px",
                      borderRadius: "10px 10px 5px 5px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      height: "auto", // Ensures expansion
                      // maxHeight: 'none', // Prevents restriction
                      zIndex: 9999, // Ensures it stays on top

                      overflowY: "visible", // Prevents unwanted scrolling
                    }}
                  >
                    <h6 className="text-1000 fs-10 py-2 mb-0 px-3">
                      {filteredLocations.length}{" "}
                      <span className="text-500">Resultados</span>
                    </h6>
                    <ResultSectionHeader title="Ubicaciones" />
                    <div
                      className="py-2 d-flex "
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        overflow: "visible", // Prevents unwanted scrolling
                        height: "auto", // Ensures expansion
                      }}
                    >
                      {filteredLocations.map((location) => (
                        <Dropdown.Item
                          as="button"
                          key={location.name}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() =>
                            onSelectLocationSuggestion(location.name)
                          }
                          className="d-flex flex-wrap align-items-center p-2 "
                          style={{ whiteSpace: "normal", width: "auto" }} // Ensures wrapping
                        >
                          <LocationTag city={location.name} />
                        </Dropdown.Item>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Search Button */}
              <Button
                className="shadow-lg"
                variant="primary"
                type="submit"
                disabled={!location && !category}
                style={{ marginLeft: "10px" }}
              >
                Buscar
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SearchTest;
// no idea why but what ended up fixing the drop down going under the category below it was removing this style from theme . css -> will figure out later
/* .bg-body-tertiary {
  --phoenix-bg-opacity: 1;
  background-color: rgba(var(--phoenix-tertiary-bg-rgb), var(--phoenix-bg-opacity)) !important;
} */
